









































































































































import { Component, Prop, Watch } from 'vue-property-decorator'
import ViewBase from '@/util/ViewBase'
import draggable from 'vuedraggable'
import { iconMap } from '@/util/resMap'
import { saveList, sendRes, getMyList } from '@/api/res'
import { toMap } from '@/fn/array'
import { Tooltip, Modal, message } from 'ant-design-vue'
import dragOut from '@/util/dragOut'
import { alert, success, confirm } from '@/util/modal'
import event from '@/fn/event'
import shortid from 'shortid'
import { getPlayList, savePlayList, getProps } from '@/util/intent'

@Component({
  components: {
    draggable,
    Tooltip,
    Modal
  }
})
// ant-design-vue api https://www.antdv.com/components/modal-cn/
export default class PlayList extends ViewBase {
  @Prop({ type: Number, default: 0 }) playId!: number

  saveListName = ''

  iconMap = iconMap

  targetCourse: any = ''

  myCourseList = []

  hasFetchMyCourseList: boolean = false

  currentItem: any = {}

  currentUseExplain: string = ''

  doc: any

  gotoPlayVisible: boolean = false


  get locale() {
    return this.$store.getters.currentLocale
  }

  get i18n() {
    const value = this.$t('login')
    return value as any
  }

  get i18nPlay() {
    const value = this.$t('playPane')
    return value as any
  }

  get playList() {
    return this.$store.state.playList
  }

  set playList(value: any[]) {
    // 排序  课程放到最后一个元素
    let lastItem: any = []
    let resValue: any = value.filter((elem: any) => {
      if (elem.res_list) {
        lastItem = elem
        return false
      }
      return !elem.res_list
    })
    resValue = [...resValue, ...lastItem]

    this.$store.commit(
      'setPlayList',
      resValue.reduce((res: any, el: any) => {
        if (el.res_list) {
          const resList = el.res_list.filter(
            (elem: any) => !res.find((ele: any) => ele.id === elem.id)
          )
          if (resList.length == 0) {
            this.$message.warning(this.i18n.vResItem.added)
          }
          return [...res, ...resList]
        }
        if (!res.find((ele: any) => ele.id === el.id)) {
          return [...res, el]
        }
        return res
      }, [])
    )
  }

  dragging = false

  get dragGroup() {
    return {
      name: 'playList',
      pull: true,
      put: (to: any, from: any, dragEl: HTMLElement) => {
        if (to == from) {
          return true
        }
        const id = parseInt(dragEl.dataset.id!, 10)
        const item = this.playList.find(it => it.id == id)
        this.$store.commit('setPlayItemIsRepeat', item != null)
        return item == null
      }
    }
  }

  saveListModel = false

  setExplainModel = false

  saveListLoading = false

  clearListModel = false

  async fetchMyCourseList() {
    // if(this.hasFetchMyCourseList) return
    try {
      const res = await getMyList()
      if (res.data && res.data.length) {
        this.myCourseList = res.data.map((el: any) => ({
          ...el,
          _id: shortid.generate()
        }))
        // this.hasFetchMyCourseList = true
      }
    } catch (ex) {
      this.handleError(ex)
    } finally {
      //
    }
  }

  async playDragStart(ev: DragEvent, id: number) {
    const box = this.$refs.playWrap as HTMLElement
    const el = ev.currentTarget as HTMLElement
    const isOut = await dragOut(box, ev, out => {
      el.classList.toggle('drag-out', out)
    })
    if (isOut) {
      this.playList = this.playList.filter(it => it.id != id)
    }
  }

  itemAdd({ item, newIndex }: any) {
    const data = item.dataset
    // const isList = data.isList != null
    // if (isList) {
    //   const idMap = toMap(this.playList, 'id')
    //   const myItem = this.myPlayList.find(it => it.id == data.id)
    //   const resItems = myItem.resource_list as any[]
    //   const items = resItems.filter(it => !(it.id in idMap))
    //   this.playList.splice(newIndex, 1, ...items)

    //   const existCount = resItems.length - items.length
    //   const msg =
    //     `已添加${items.length}个` + (existCount > 0 ? `，${existCount}个已存在` : '')
    //   message.success(msg)
    // }
  }

  // 手动控制去上课提示的显示隐藏
  mouseenter() {
    this.gotoPlayVisible = true
  }

  mouseleave() {
    this.gotoPlayVisible = false
  }
  gotoPlay(item: any) {
    this.gotoPlayVisible = false
    this.$router.push({
      name: 'playIndex',
      params: {
        id: '0',
        resourceId: item.id
      }
    })
  }

  async saveListClick() {
    if (this.playList.length == 0) {
      alert(this.i18nPlay.listIsEmpty)
      return
    }
    this.fetchMyCourseList()
    this.saveListModel = true
    this.targetCourse = ''
    this.saveListName = ''
  }

  async saveListSubmit() {
    const ids = {}
    this.playList.map(it => {
      const tmp: any = {}
      tmp[it.id] = it.use_explain
      Object.assign(ids, tmp)
    })
    let title = this.saveListName.trim()
    const id = this.targetCourse
    if (!id && title == '') {
      alert(this.i18nPlay.titleEmpty)
      return
    }
    // console.log(this.$i18n.locale)
    if (this.$i18n.locale == 'zh') {
      if (title.length > 20) {
        alert(this.i18n.vsider.tipmore)
        return
      }
    } else {
      if (title.length > 40) {
        alert(this.i18n.vsider.tipmore)
        return
      }
    }

    if (id) {
      title = (this.myCourseList.find((el: any) => el.id === id) as any).course_title
    }
    this.saveListLoading = true
    try {
      const pdata = {
        id,
        title,
        resource_ids: ids
      }
      await saveList(pdata)
      message.success(this.i18nPlay.saveDone)
      this.saveListModel = false
    } catch (ex) {
      this.handleError(ex)
    } finally {
      this.$store.commit('setNeedRefreshMyCourse', true)
      this.saveListLoading = false
    }
  }

  async sendResClick() {
    this.gotoPlayVisible = false
    this.$store.commit('setplayALL', {})
    this.$router.push({
      name: 'playIndex',
      params: {
        id:  this.playList[0].id + ''
      }
    })
  }

  async clearList() {
    if (this.playList.length == 0) {
      alert(this.i18nPlay.listIsEmpty)
      return
    }

    // await confirm(this.i18nPlay.clearListTip, this.i18nPlay.clearListConfirm)
    this.playList = []
    this.clearListModel = false
  }

  handleSelect(v: any) {
    this.targetCourse = v
  }

  // 设置使用建议
  setExplainClick(item: any, index: number) {
    this.setExplainModel = true
    this.currentItem = item
    this.currentUseExplain = item.use_explain || ''
  }

  setExplainSubmit() {
    const index = this.playList.findIndex(value => value.id == this.currentItem.id)
    this.playList.splice(index, 1, this.currentItem)
    this.playList = this.playList
    this.setExplainModel = false
  }
  cancelEditModal() {
    this.currentItem.use_explain = this.currentUseExplain
    this.setExplainModel = false
  }
  clearListModal() {
    this.clearListModel = true
  }

  cancelClearModal() {
    this.clearListModel = false
  }
  @Watch('playList')
  watchPlayList(value: any[]) {
    const list = JSON.parse(JSON.stringify(value))
    savePlayList(list)
  }
  created() {
    this.doc = window.document
  }
}
